import {Injectable} from '@angular/core';
import {NGXLogger} from "ngx-logger";
import {LocalStorageService} from "@shared/services/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class BrowserNotificationService {
  private openedTab: Window | null = null;

  constructor(
    private readonly logger: NGXLogger,
    private readonly localStorageService: LocalStorageService
  ) {
  }

  private async requestPermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) {

      this.logger.warn('This browser does not support Notifications');

      return 'denied';
    }

    if (Notification.permission === 'granted') {
      return 'granted';
    }

    return await Notification.requestPermission();
  }

  async enableNotifications() {
    const permission = await this.requestPermission();

    if (permission === 'granted') {
      if (!await this.localStorageService.getData('notification_enabled')) {
        await this.localStorageService.saveData('notification_enabled', true);
      }
    }

    if (permission === 'denied') {
      await this.localStorageService.saveData('notification_enabled', false)
    }
  }

  showNotification(title: string, options?: NotificationOptions, url: string = null): void {
    if (!document.hidden) {
      this.logger.info('Skip notification because tab is active');

      return;
    }

    if (Notification.permission === 'granted') {
      const notification = new Notification(title, options);

      url = url ?? window.location.origin

      notification.onclick = () => {
        if (this.openedTab && !this.openedTab.closed) {
          this.openedTab.focus();
          this.openedTab.location.href = url; // optional: redirect
        } else {
          this.openedTab = window.open(url, '_blank');
        }
      }

    } else {
      this.logger.warn('We dont have permission, cannot show the notification');
    }
  }
}
